import Slider from '@ant-design/react-slick';
import { ClassName } from '@boxcryptor-web/shared/class-name';
import classnames from 'classnames';
import * as React from 'react';
import { IconButton } from '../IconButton';
import { DynamicIcon } from '../icons';
import './slick-theme.css';
import './slick.css';

export interface Slide {
  imgUrl: string;
  description?: string;
  altText?: string;
}

const SliderArrow: React.FC<{ onClick: () => void; type: 'prev' | 'next' }> = ({ onClick, type }) => (
  <div className={classnames('absolute inset-y-0 z-50 hidden sm:flex items-center justify-center', type === 'prev' ? 'left-0' : 'right-0')}>
    <IconButton
      onClick={onClick}
      icon={
        type === 'prev' ? (
          <DynamicIcon identifier="chevron-left-solid" className="h-12 w-12" />
        ) : (
          <DynamicIcon identifier="chevron-right-solid" className="h-12 w-12" />
        )
      }
    />
  </div>
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SliderArrowPrev(props: any) {
  return <SliderArrow onClick={props.onClick} type="prev" />;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SliderArrowNext(props: any) {
  return <SliderArrow onClick={props.onClick} type="next" />;
}

export const SlideShow: React.FC<ClassName & { children?: React.ReactNode }> = ({ className, children }) => {
  return (
    <Slider
      dots={true}
      autoplay={true}
      autoplaySpeed={7000}
      pauseOnDotsHover={true}
      infinite={true}
      prevArrow={<SliderArrowPrev />}
      nextArrow={<SliderArrowNext />}
      className={className}
      draggable={false}
      swipe={false}
    >
      {children}
    </Slider>
  );
};
